import axios from 'axios';
import config from '../config';
import { handlingSession, sessionID } from './../../utils/handlingSession'
import { userLogs } from './../logs/userLogs'

export const privacyPolicyStatus = async (formData) => {
    const url = `${config.hummBackendAppURL}broker-application/get-status-of-privacy-policy-notify?applicationId=${formData.applicationId}&isWeb=${formData.isWeb}`;

    try {
        const response = await axios.get(url, { headers: sessionID('secured') });
        return response;
    } catch (error) {
        await userLogs(url, formData, error);
        if (error.response) {
            handlingSession(error.response.status);
        }
        return error.response;
    }
};
